// import addRequest from './addRequest';
import appStrings from '@/app/utility/string.utility';
import commonItemModal from '../commonItemModal';
import { required } from 'vuelidate/lib/validators';
// import commonHelper from '@/app/utility/common.helper.utility';
// import store from '../../../../store';
import HistoryRecord from '@/app/components/onlineApproval/internalWorkFlow/history/historyRecord';
import ApprovalHistory from '@/app/components/onlineApproval/internalWorkFlow/history/approvalHistory';
import UploadDocument from '@/app/components/onlineApproval/internalWorkFlow/history/uploadDocument';
import sendForApproval from '@/app/components/onlineApproval/internalWorkFlow/history/sendForApproval';
import openKmAuthentication from '@/app/components/onlineApproval/internalWorkFlow/openKmAuthentication';

export default {
  name: 'rfp',
  components: {
    commonItemModal,
    // addRequest,
    HistoryRecord,
    ApprovalHistory,
    UploadDocument,
    sendForApproval,
    openKmAuthentication
  },
  props: ['rowData', 'wfItemDetails'],
  data() {
    return {
      showValueSetModal: false,
      vsetCode: null,
      parent_value_set_id: null,
      loader: false,
      editMode: false,
      showAlert: false,
      responseMsg: '',
      isSuccess: false,
      itemType: {
        text: null,
        value: null
      },
      itemCode: null,
      natureItem: {
        text: null,
        value: null
      },
      description: null,
      longDesc: null,
      uom: {
        text: null,
        value: null
      },
      template: {
        text: null,
        value: null
      },
      status: {
        text: 'ACTIVE',
        value: 'ACTIVE'
      },
      approvalStatus: 'DRAFT',
      expenseAcc: {
        text: null,
        value: null
      },
      assetCat: {
        text: null,
        value: null
      },
      taxCat: null,
      // hsnCode: null,
      sacCode: null,
      taxRecover: {
        text: null,
        value: null
      },
      taxRate: {
        text: null,
        value: null
      },
      tcs: false,
      unitRate: null,
      modalType: null,
      showCommonModal: false,
      itemHdrId: 0,
      vendorCode: null,
      poNumber: null,
      financeFlag: null,
      taxFlag: null,
      showApproveRejectModal: false,
      approvRejectType: null,
      approvalReason: null,
      rejectedReason: null,
      approvalRemarks: null,
      rejectionRemarks: null,
      urlSummaryData: null,
      wfApprovalStatus: null,
      approvalStatusKey: null,
      isFinalApprover: null,
      showHistory: false,
      historyType: null,
      showOpenKmModal: false,
      openkmAuthToken: null,
      oraclePostingStatus: null
    };
  },
  validations: {
    natureItem: {
      value: { required }
    },
    itemType: {
      value: { required }
    },
    // template: {
    //   value: { required }
    // },
    uom: {
      value: { required }
    },
    // itemCode: {
    //    required
    // },
    description: {
       required
    },
    // longDesc: {
    //    required
    // },
    unitRate: { required },
    sacCode: { required }
  },
  mounted() {
    if (this.rowData) {
      // from grid
      this.itemHdrId = this.rowData.item_id;
      this.getItemHdrById();
    }
    else {
      this.editMode = true;
    }
    if (this.wfItemDetails) {
      // from dashboard
      this.itemHdrId = this.wfItemDetails.item_id;
      this.getItemHdrById();
    }
    if (this.$route.params.summaryData) {
      this.urlSummaryData = JSON.parse(
        Buffer.from(this.$route.params.summaryData, 'base64').toString('ascii')
      );
    }
    if (this.urlSummaryData) {
      // from link
      this.itemHdrId = this.urlSummaryData.item_id;
      this.getItemHdrById();
    }
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save' && this.editMode) {
          // if (this.approvalStatus === 'DRAFT' || this.approvalStatus === 'REJECTED' || this.approvalStatus === 'APPROVED') {
            this.validateCreateItemData();
          // }
        }
        if (actionName === 'update') {
          this.editMode = true;
        } 
      }
    });
  },
  methods: {
  validateCreateItemData() {
  if (this.taxFlag === 'ACTIVE') {
    if (this.itemType.text === 'Inventory Items') {
      if (this.expenseAcc.text) {
        this.addEditItemCreateData();
      } else {
        alert('Expense Account is Mandatory!');
      }
    } else if (this.itemType.text === 'Capital Asset') {
      if (this.assetCat.text) {
        this.addEditItemCreateData();
      } else {
        alert('Asset Category is Mandatory!');
      }
    }
    } else if (this.wfApprovalStatus === 'INPROCESS') {
      if (this.taxRate.text && this.taxRecover.text) {
        this.addEditItemCreateData();
      } else {
        alert('Tax Rate & Tax Recoverable is Mandatory!');
      }
    } 
    else {
    this.addEditItemCreateData();
    }
  },
    addEditItemCreateData(){
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const payload = {
          item_type: this.itemType.value,
          item_type_meaning: this.itemType.text,
          item_code: this.itemCode,
          description: this.description,
          long_description: this.longDesc,
          uom: this.uom.value,
          uom_meaning: this.uom.text,
          template: this.template.value,
          template_meaning: this.template.text,
          expense_account: this.expenseAcc.value,
          expense_account_meaning: this.expenseAcc.text,
          // asset_cat: this.assetCat.value,
          asset_cat_name: this.assetCat.text,
          status: this.status.value,
          approval_status: this.approvalStatus,
          hsn_code: this.sacCode,
          // sac_code: this.sacCode,
          tax_recoverable: this.taxRecover.value,
          nature_of_item: this.natureItem.value,
          nature_of_item_meaning: this.natureItem.text,
          tax_rate: this.taxRate.text,
          tax_rate_id: this.taxRate.value,
          item_id: this.itemHdrId,
          tcs: this.tcs,
          unit_rate: this.unitRate
        };
          this.loader = true;
          this.$store
            .dispatch('purchaseRequisition/addEditItemCreateData', payload)
            .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) { 
            // this.$emit('rowSelected', response.data.data.item_id);
            this.editMode = false;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
            this.itemHdrId = response.data.data.item_id;
            this.$emit('updateItemData', this.itemHdrId);
            this.getItemHdrById();
          } else {
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        // .catch(() => {
        //   this.loader = false;
        //   this.isSuccess = false;
        //   this.responseMsg = appStrings.autoFailedMsg;
        // });
      }
    },
    getItemHdrById() {
      const payload = {
        item_id: this.itemHdrId,
        requestPayload: {
          userId: this.$store.state.auth.userId
        }
      }
      this.loader = true;
      this.$store
        .dispatch('purchaseRequisition/getItemHdrById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.natureItem.text = result.nature_of_item_meaning;
            this.natureItem.value = result.nature_of_item;
            this.itemType.text = result.item_type_meaning;
            this.itemType.value = result.item_type;
            this.template.text = result.template_meaning;
            this.template.value = result.template;
            this.uom.text = result.uom_meaning;
            this.uom.value = result.uom;
            this.itemCode = result.item_code;
            this.description = result.description;
            this.longDesc = result.long_description;
            this.expenseAcc.text = result.expense_account_meaning;
            this.expenseAcc.value = result.expense_account;
            this.assetCat.text = result.asset_cat_name;
            this.taxRate.text = result.tax_rate;
            this.taxRate.value = result.tax_rate_id;
            this.tcs = result.tcs;
            // this.hsnCode = result.hsn_code;
            this.sacCode = result.hsn_code;
            this.taxRecover.text = result.tax_recoverable;
            this.unitRate = result.unit_rate;
            this.taxFlag = result.tax_dept;
            this.financeFlag = result.fin_dept;
            this.approvalStatus = result.approval_status;
            this.wfApprovalStatus = result.approval_status_key;
            this.approvalStatusKey = result.approval_status_key;
            this.isFinalApprover = result.is_final_approver;
            this.oraclePostingStatus = result.oracle_status;
            if (this.approvalStatus === 'APPROVED' && !this.oraclePostingStatus) {
              this.getApprovedItemById();
            }
            // this.itemHdrId = result.item_id;
            // this.$emit('updateItemData', this.itemHdrId);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getApprovedItemById() {
      const payload = {
        item_id: this.itemHdrId,
        status: this.approvalStatus
      }
      this.loader = true;
      this.$store
        .dispatch('purchaseRequisition/getApprovedItemById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.ouName = resp.data.data.ou_name;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    sacCodeValidate(){
      const trimmedSacCode = this.sacCode.trim();
      if(!trimmedSacCode.startsWith('99')){
        alert('SAC Code must start with "99"');
        this.sacCode = null;
      }
      // if (trimmedSacCode.length < 6 || trimmedSacCode.length > 8) {
      if(trimmedSacCode.length !== 6 && trimmedSacCode.length !== 8){
        alert('SAC Code must be 6 or 8 digits long');
        this.sacCode = null;
        return;
      } 
    },
    qtyTwoDecimalValue() {
      if (this.unitRate) {
        if (this.unitRate.charAt(0) === '.') {
          this.unitRate = '0.';
        } else {
          var regex = /^\d+(\.\d{0,2})?$/g;
          if (!regex.test(this.unitRate)) {
            alert('Only two decimal places are allowed.');
            const [integerPart, decimalPart] = this.unitRate.split('.');
            const truncatedDecimal = parseFloat(
              `${integerPart}.${decimalPart.slice(0, 2)}`
            );
            setTimeout(() => {
              this.unitRate = truncatedDecimal;
            }, 0);
          }
        }
      }
    },
    showHideHistory(flag, historyType) {
      this.showHistory = flag;
      this.historyType = historyType;
      if (!flag) {
        this.getItemHdrById();
      }
    },
    // async isDocumentUploadedFunc() {
    //   const uploadedDocList = await commonHelper.getUploadedDocList(
    //     this.$store.state.shared.menuId,
    //     this.selectedItemDetail.prov_hdr_id
    //   );
    // const isDocumentUploaded = uploadedDocList.length > 0;
    // isDocumentUploaded
    //   ? this.showHideHistory(true, 'sendForApproval')
    //   : alert('Please upload document!');
    // },
    validateUploadDocument() {
      // if (this.selectedItemDetail.approval_status === 'DRAFT') {
      //   this.isDocumentUploadedFunc();
      // } else {
      this.showHideHistory(true, 'sendForApproval');
      // }
    },
    checkOpenKmPasswordSaved() {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/checkSavedPassword')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            if (response.data.data) {
              this.getOpenKmAuthToken();
            } else {
              this.showHideOpenKmModal(true);
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getOpenKmAuthToken() {
      const payload = {
        password: null,
        saved_password_flag: true,
        user_name: null
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmAuthenticate', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openkmAuthToken = response.data.data.token;
            // this.selectedGridData = {
            //   ...this.selectedItemDetail,
            //   nfa_cat_vset: null,
            //   nfa_cat: null,
            //   nfa_sub_cat_vset: null,
            //   nfa_sub_cat: null
            // };
            this.showHideHistory(true, 'uploadDocument');
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideOpenKmModal(flag) {
      this.showOpenKmModal = flag;
    },
    setOpenKmToken(token) {
      this.showHideOpenKmModal(false);
      this.openkmAuthToken = token;
      // this.selectedGridData = {
      //   ...this.selectedItemDetail,
      //   nfa_cat_vset: null,
      //   nfa_cat: null,
      //   nfa_sub_cat_vset: null,
      //   nfa_sub_cat: null
      // };
      this.showHideHistory(true, 'uploadDocument');
    },
    showHideApproveRejectModal(flag, type) {
      this.showApproveRejectModal = flag;
      this.approvRejectType = type;
    },
    approveRejectItem(status) {
      const payload = {
        event_id: this.rowData ? this.rowData.wf_event_id : this.wfItemDetails ? this.wfItemDetails.wf_event_id : null,
        wf_inprocess_dtl_id: this.rowData ? this.rowData.wf_inprocess_dtl_id : this.wfItemDetails ? this.wfItemDetails.wf_inprocess_dtl_id : null,
        notification_status: status,
        notification_comments:
          status === 'REJECTED' ? this.rejectedReason : this.approvalReason
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/approvalRejectSingle', payload)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.editMode = false;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
            if (status === 'REJECTED') {
              this.showHideApproveRejectModal(false);
            } else if (status === 'APPROVED') {
              this.showHideApproveRejectModal(false);
            }
            this.getItemHdrById();
            // this.$emit('updateInvoice');
          } else {
            this.showAlert = false;
            alert(response.response.data.message);
            // this.isSuccess = false;
            // this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openValueSetModal(vsetCode) {
      this.showValueSetModal = true;
      this.vsetCode = vsetCode;
      this.parent_value_set_id = null;
      if (this.vsetCode === appStrings.VALUESETTYPE.TAX_CATEGORY_NAME_VSET) {
          this.parent_value_set_id = 1;
          this.showValueSetModal = true;
      }
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.NATURE_OF_ITEM) {
        this.natureItem = {
          value: item.value_code,
          text: item.value_meaning
        };
        this.natureItemFillAutoData();
      } else if (this.vsetCode === appStrings.VALUESETTYPE.STATUS_VSET) {
        this.status = {
          value: item.value_code,
          text: item.value_meaning
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.YES_NO) {
        this.taxRecover = {
          value: item.value_code,
          text: item.value_meaning
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.TAX_CATEGORY_NAME_VSET) {
        this.taxRate = {
          value: item.value_set_dtl_id,
          text: item.value_code
        };
      }
      this.showValueSetModal = false;
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    natureItemFillAutoData(){
      if(this.natureItem.text === 'Capital Goods'){
      this.itemType = {
        text: 'Capital Asset',
        value: 'CA'
      };
      this.template = {
        text: 'Capital Asset',
        value: '3084'
      }
    } else { 
      this.itemType = {
        text: null,
        value: null
      };
      this.template = {
        text: null,
        value: null
      };
    }
    },
    showHideCommonModal(flag, type) {
        this.modalType = type;
        this.showCommonModal = flag;
        if (flag) {
          if (this.modalType === 'period') {
            this.legalEntityValue = this.legalEntity.value;
          }
        } if (this.modalType === 'period' && !this.legalEntity.text) {
          this.showCommonModal = false;
          alert('Please Select Legal Entity.')
        } else {
          this.showCommonModal = flag;
        }
    },
    mapSelectedVsetData(item) {
        if (this.modalType === 'item_type') {
          this.itemType = {
            text: item.meaning,
            value: item.lookup_code
          };
        } else if (this.modalType === 'uom') {
            this.uom = {
                text: item.unit_of_measure,
                value: item.uom_code
              };
        } else if (this.modalType === 'template') {
            this.template = {
                text: item.description,
                value: item.temp_id
              };
        } else if (this.modalType === 'asset_cat') {
            this.assetCat = {
                text: item.cat,
                value: item.cat
              };
        } else if (this.modalType === 'expense_acc') {
            this.expenseAcc = {
                text: item.description,
                value: item.flex_value
              };
        } else if (this.modalType === 'tax_rate') {
            this.taxRate = {
              text: item.reporting_code_description,
              value: item.reporting_code
          };
        }
        this.showHideCommonModal(false);
    },
    clearVsetValues(vsetCode) {
            switch (vsetCode) {
              case 'item_type':
                this.itemType = {
                    text: null,
                    value: null
                };
                break;
              case 'uom':
                this.uom = {
                    text: null,
                    value: null
                };
                break;
              case 'template':
                this.template = {
                    text: null,
                    value: null
                };
                break;
              case 'expense_acc':
                this.expenseAcc = {
                    text: null,
                    value: null
                };
                break;
              case 'asset_cat':
                this.assetCat = {
                    text: null,
                    value: null
                };
                break;
              case 'tax_rate':
                this.taxRate = {
                    text: null,
                    value: null
                };
                break;
              case appStrings.VALUESETTYPE.NATURE_OF_ITEM:
                this.natureItem = {
                    value: null,
                    text: null
                  };
                break;
              case appStrings.VALUESETTYPE.STATUS_VSET:
                this.status = {
                    value: null,
                    text: null
                  };
                break;
                case appStrings.VALUESETTYPE.YES_NO:
                  this.taxRecover = {
                      value: null,
                      text: null
                    };
                  break;
                  case appStrings.VALUESETTYPE.TAX_CATEGORY_NAME_VSET:
                    this.taxRate = {
                        value: null,
                        text: null
                      };
                    break;
            }
    },
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};